import { createSelector } from 'reselect';

const getReducer = (state) => state.projects;

export const selectProjectsList = createSelector(
  getReducer,
  ({ list }) => list
);

export const selectProjectById = createSelector(
  getReducer,
  ({ list }) => (id) => list.find((project) => project.Id === id)
);

export const selectProjectsParsedList = createSelector(
  getReducer,
  ({ parsedList }) => parsedList
);

export const selectProjectsOptionsList = createSelector(
  getReducer,
  ({ options }) => options
);

export const selectLoadFetching = createSelector(
  getReducer,
  ({ loadFetching }) => loadFetching
);

export const selectCreateFetching = createSelector(
  getReducer,
  ({ createFetching }) => createFetching
);

export const selectUpdateFetching = createSelector(
  getReducer,
  ({ updateFetching }) => updateFetching
);

export const selectDeleteFetching = createSelector(
  getReducer,
  ({ deleteFetching }) => deleteFetching
);

export const selectAssociationsJobsFetching = createSelector(
  getReducer,
  ({ associationsJobsFetching }) => associationsJobsFetching
);

export const selectAssociationsUsersFetching = createSelector(
  getReducer,
  ({ associationsUsersFetching }) => associationsUsersFetching
);

export const selectAssociationsJobsDeleteFetching = createSelector(
  getReducer,
  ({ associationsJobsDeleteFetching }) => associationsJobsDeleteFetching
);

export const selectAssociationsUsersDeleteFetching = createSelector(
  getReducer,
  ({ associationsUsersDeleteFetching }) => associationsUsersDeleteFetching
);

export const selectCurrentProjectFetching = createSelector(
  getReducer,
  ({ currentProjectFetching }) => currentProjectFetching
);

export const selectCurrentProject = createSelector(
  getReducer,
  ({ currentProject }) => currentProject
);

export const selectCurrentProjectId = createSelector(
  getReducer,
  ({ currentProjectId }) => currentProjectId
);
